module.exports = __webpack_public_path__ + "static/media/slider-left-white.74494afd.cur";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/slider-left-white.cur
// module id = 66
// module chunks = 0